import classNames from 'classnames';

import { Label, Radio } from 'flowbite-react';
import React from 'react';
import StarRatings from 'react-star-ratings';
import { Meeting, MentorFeedbackCreateInfo } from 'types';

interface Props {
	rating: number;
	handleRating: (rate: number) => void;
	meeting: Meeting;
	mentorFeedback: MentorFeedbackCreateInfo;
	setMentorFeedback: (args: MentorFeedbackCreateInfo) => void;
	isEditable: boolean;
}

const FirstStepForm = ({ rating, handleRating, meeting, mentorFeedback, setMentorFeedback, isEditable }: Props) => {
	return (
		<div className="mb-3 w-full">
			<div className="flex w-full flex-col gap-y-7">
				{/* Score calculated as expected based on the feedback provided ? */}
				<div>
					<div className="font-inter text-[16px]">
						Was the score calculated as expected based on the feedback you provided?{' '}
						<span className="text-red-600">*</span>
					</div>
					<div className="flex flex-wrap gap-3 mt-2">
						<div className="flex items-center gap-2">
							<Radio
								disabled={!isEditable}
								checked={mentorFeedback.wasScoreCalculatedCorrectly === 'Yes'}
								onChange={event => {
									setMentorFeedback({ ...mentorFeedback, wasScoreCalculatedCorrectly: event.target.value });
								}}
								className={classNames(isEditable ? 'cursor-pointer' : '')}
								id="score-calculation-yes"
								name="score-calculation"
								value="Yes"
							/>
							<Label htmlFor="score-calculation-yes">Yes</Label>
						</div>
						<div className="flex items-center gap-2">
							<Radio
								disabled={!isEditable}
								checked={mentorFeedback.wasScoreCalculatedCorrectly === 'Expected more'}
								onChange={event => {
									setMentorFeedback({ ...mentorFeedback, wasScoreCalculatedCorrectly: event.target.value });
								}}
								id="score-calculation-ExpectedMore"
								className={classNames(isEditable ? 'cursor-pointer' : '')}
								name="score-calculation"
								value="Expected more"
							/>
							<Label htmlFor="score-calculation-ExpectedMore">Expected more</Label>
						</div>
						<div className="flex items-center gap-2">
							<Radio
								disabled={!isEditable}
								checked={mentorFeedback.wasScoreCalculatedCorrectly === 'Expected Less'}
								onChange={event => {
									setMentorFeedback({ ...mentorFeedback, wasScoreCalculatedCorrectly: event.target.value });
								}}
								id="score-calculation-ExpectedLess"
								className={classNames(isEditable ? 'cursor-pointer' : '')}
								name="score-calculation"
								value="Expected Less"
							/>
							<Label htmlFor="score-calculation-ExpectedLess">Expected Less</Label>
						</div>
					</div>
				</div>
				{/* Was the predicted salary a good approximate? */}
				<div>
					<div className="font-inter text-[16px]">
						Was the predicted salary a good approximate of the candidate based on their performance?
						<span className="text-red-600">*</span>
					</div>
					<div className="flex flex-wrap gap-3 mt-2">
						<div className="flex items-center gap-2">
							<Radio
								disabled={!isEditable}
								checked={mentorFeedback.predictedSalary === 'Yes'}
								onChange={event => {
									setMentorFeedback({ ...mentorFeedback, predictedSalary: event.target.value });
								}}
								className={classNames(isEditable ? 'cursor-pointer' : '')}
								id="predictedSalary-yes"
								name="predictedSalary"
								value="Yes"
							/>
							<Label htmlFor="predictedSalary-yes">Yes</Label>
						</div>
						<div className="flex items-center gap-2">
							<Radio
								disabled={!isEditable}
								checked={mentorFeedback.predictedSalary === 'Expected more'}
								onChange={event => {
									setMentorFeedback({ ...mentorFeedback, predictedSalary: event.target.value });
								}}
								id="predictedSalary-ExpectedMore"
								className={classNames(isEditable ? 'cursor-pointer' : '')}
								name="predictedSalary"
								value="Expected more"
							/>
							<Label htmlFor="predictedSalary-ExpectedMore">Expected more</Label>
						</div>
						<div className="flex items-center gap-2">
							<Radio
								disabled={!isEditable}
								checked={mentorFeedback.predictedSalary === 'Expected Less'}
								onChange={event => {
									setMentorFeedback({ ...mentorFeedback, predictedSalary: event.target.value });
								}}
								id="predictedSalary-ExpectedLess"
								className={classNames(isEditable ? 'cursor-pointer' : '')}
								name="predictedSalary"
								value="Expected Less"
							/>
							<Label htmlFor="predictedSalary-ExpectedLess">Expected Less</Label>
						</div>
					</div>
				</div>
				{/* how confident are you that candidate will complete the assigned path? */}
				<div>
					<div className="font-inter text-[16px]">
						Basis your conversation, how confident are you that candidate will complete the assigned path?
						<span className="text-red-600">*</span>
					</div>
					<div className="flex flex-wrap gap-3 mt-2">
						<div className="flex  items-center gap-2">
							<Radio
								disabled={!isEditable}
								checked={mentorFeedback.candidateIntent === 'Very Confident'}
								onChange={event => {
									setMentorFeedback({ ...mentorFeedback, candidateIntent: event.target.value });
								}}
								id="question-relevance-vc"
								name="candidateIntent"
								className={classNames(isEditable ? 'cursor-pointer' : '')}
								value="Very Confident"
							/>
							<Label htmlFor="question-relevance-yes">Very Confident</Label>
						</div>
						<div className="flex items-center gap-2">
							<Radio
								disabled={!isEditable}
								checked={mentorFeedback.candidateIntent === 'Confident'}
								onChange={event => {
									setMentorFeedback({ ...mentorFeedback, candidateIntent: event.target.value });
								}}
								id="question-relevance-c"
								name="candidateIntent"
								className={classNames(isEditable ? 'cursor-pointer' : '')}
								value="Confident"
							/>
							<Label htmlFor="question-relevance-no">Confident</Label>
						</div>
						<div className="flex items-center gap-2">
							<Radio
								disabled={!isEditable}
								checked={mentorFeedback.candidateIntent === 'Not Sure'}
								onChange={event => {
									setMentorFeedback({ ...mentorFeedback, candidateIntent: event.target.value });
								}}
								id="question-relevance-ns"
								name="candidateIntent"
								className={classNames(isEditable ? 'cursor-pointer' : '')}
								value="Not Sure"
							/>
							<Label htmlFor="question-relevance-yes">Not Sure</Label>
						</div>
						<div className="flex items-center gap-2">
							<Radio
								disabled={!isEditable}
								checked={mentorFeedback.candidateIntent === "Candidate wasn't interested"}
								onChange={event => {
									setMentorFeedback({ ...mentorFeedback, candidateIntent: event.target.value });
								}}
								id="question-relevance-no"
								className={classNames(isEditable ? 'cursor-pointer' : '')}
								name="candidateIntent"
								value="Candidate wasn't interested"
							/>
							<Label htmlFor="question-relevance-no">Candidate wasn't interested</Label>
						</div>
					</div>
				</div>
				{/* Were the questions asked relevant as per industry standards? */}
				<div>
					<div className="font-inter text-[16px]">
						In your opinion, were the questions asked relevant as per industry standards?
						<span className="text-red-600">*</span>
					</div>
					<div className="flex flex-wrap gap-3 mt-2">
						<div className="flex items-center gap-2">
							<Radio
								disabled={!isEditable}
								checked={mentorFeedback.questionRelevance === 'Yes'}
								onChange={event => {
									setMentorFeedback({ ...mentorFeedback, questionRelevance: event.target.value });
								}}
								id="questionRelevance-yes"
								name="questionRelevance"
								className={classNames(isEditable ? 'cursor-pointer' : '')}
								value="Yes"
							/>
							<Label htmlFor="questionRelevance-yes">Yes</Label>
						</div>
						<div className="flex items-center gap-2">
							<Radio
								disabled={!isEditable}
								checked={mentorFeedback.questionRelevance === 'Could Be Better'}
								onChange={event => {
									setMentorFeedback({ ...mentorFeedback, questionRelevance: event.target.value });
								}}
								id="questionRelevance-cbb"
								name="questionRelevance"
								className={classNames(isEditable ? 'cursor-pointer' : '')}
								value="Could Be Better"
							/>
							<Label htmlFor="questionRelevance-no">Could Be Better</Label>
						</div>
						<div className="flex items-center gap-2">
							<Radio
								disabled={!isEditable}
								checked={mentorFeedback.questionRelevance === 'No'}
								onChange={event => {
									setMentorFeedback({ ...mentorFeedback, questionRelevance: event.target.value });
								}}
								id="questionRelevance-no"
								name="questionRelevance"
								className={classNames(isEditable ? 'cursor-pointer' : '')}
								value="No"
							/>
							<Label htmlFor="questionRelevance-yes">No</Label>
						</div>
					</div>
				</div>
				{/* Rate your overall experience */}
				<div>
					<p className="font-inter text-[16px]">
						Rate your overall experience<span className="text-red-600">*</span>
					</p>
					<div className="simple-star-rating-containermt-1">
						<StarRatings
							rating={rating}
							starDimension="34px"
							starRatedColor="#e3a008"
							starHoverColor="#e3a008"
							changeRating={handleRating}
							numberOfStars={5}
							name="rating"
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FirstStepForm;
